import { Box, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ErrorLabel = styled(Typography)(({ theme }) => ({
    color: "#333333",
    fontSize: "22px",
    fontWeight: "500",
    letterSpacing: 0,
    lineHeight: "27px",
}));

const ErrorMessage = () => {
    const { t } = useTranslation();

    return (
        <Box display={"flex"} alignItems="center" justifyContent="center">
            <ErrorLabel>{t("Errors.Error loading mortgage. Please reload the page.")}</ErrorLabel>
        </Box>
    );
};

export default ErrorMessage;
